module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/massage-mobile-d4b25c5c969316204074ebd33daf2622.jpg";